export class VerticalSpacer {
  size: string;
  sm?: string;
  md?: string;
  lg?: string;

  constructor(props: any) {
    const unit = (u: string) => u || 'px';

    const sm =
      props.customSpaceSizeSmall ||
      props.customSpaceSize ||
      props.customSpaceSizeLarge;
    const md =
      props.customSpaceSize ||
      props.customSpaceSizeLarge ||
      props.customSpaceSizeSmall;
    const lg =
      props.customSpaceSizeLarge ||
      props.customSpaceSize ||
      props.customSpaceSizeSmall;

    this.sm = sm ? sm + unit(props.customSpaceUnitSmall) : undefined;
    this.md = md ? md + unit(props.customSpaceUnit) : undefined;
    this.lg = lg ? lg + unit(props.customSpaceUnitLarge) : undefined;

    this.size = props.size ? props.size.toLowerCase() : 'medium';
  }
}

export default VerticalSpacer;
